<template>
  <div v-if="dataLoaded" :class="{ 'all-wrap': true, '--wide': wideMode }">
    <Sidebar @viewchange="changeViewMode()" />
    <Notifications />
    <div class="content">
      <!-- @artist-hover="makeWhite()"
        @normal-state="makeNormal()" -->
      <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transition || 'pages-fade'">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/Sidebar.vue"
import Notifications from "@/components/Notifications.vue"
import axios from "axios"

export default {
  name: "App",
  components: { Sidebar, Notifications },
  data() {
    return {
      // whiteTheme: false,
      // apiUrl: "http://159f-gallery.com/panel/api/",
      dataLoaded: false,
      wideMode: false,
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll)
    localStorage.setItem("startUrl", window.location.href)

    if (localStorage.getItem("userRole")) {
      let role = localStorage.getItem("userRole")
      let token = localStorage.getItem("userRoleToken")
      axios
        .post(
          this.params.apiUrl + "auth_token_check",
          {
            token: token,
            role: role,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          let data = response.data
          if (data.checked) {
            this.$store.dispatch(
              "setUserRole",
              localStorage.getItem("userRole")
            )
            this.$store.dispatch(
              "setUserId",
              parseInt(localStorage.getItem("userId"))
            )
            this.loadStartDicts()
            // window.location.href = currentUrl
          } else {
            this.$router.push("/login")
          }
        })
    } else if (this.$router.name != "login") {
      this.$router.push("/login")
    }
  },
  mounted() {
    // if (process.env.VUE_APP_API_URL != undefined)
    //   this.apiUrl = process.env.VUE_APP_API_URL

    if (!this.modules.length) {
      axios.get(this.params.apiUrl + "modules/list").then((response) => {
        let data = response.data
        this.$store.dispatch("setModulesList", data)
        this.dataLoaded = true
      })
    }

    // if (!t his.dict.accCategories.length) {
    //   axios.get(this.params.apiUrl + "dict/acc_categories").then((response) => {
    //     let data = response.data
    //     this.$store.dispatch("setAccCategories", data)
    //   })
    // }
  },
  computed: {
    params() {
      return this.$store.getters.getParams()
    },
    dict() {
      return this.$store.getters.getDict()
    },
    modules() {
      return this.$store.getters.getModules()
    },
  },
  methods: {
    handleScroll() {},
    changeViewMode() {
      this.wideMode = !this.wideMode
    },
    loadStartDicts() {
      if (this.$store.getters.getUserRole()) {
        if (!this.dict.orderStatuses.length) {
          axios
            .get(this.params.apiUrl + "dict/order_statuses")
            .then((response) => {
              let data = response.data
              this.$store.dispatch("setOrderStatuses", data)
            })
        }
        if (!this.dict.orderManagers.length) {
          axios.get(this.params.apiUrl + "dict/managers").then((response) => {
            let data = response.data
            this.$store.dispatch("setOrderManagers", data)
          })
        }
        if (!this.dict.paymentTypes.length) {
          axios
            .get(this.params.apiUrl + "dict/payment_types")
            .then((response) => {
              let data = response.data
              this.$store.dispatch("setPaymentTypes", data)
            })
        }
        if (!this.dict.deliveryTypes.length) {
          axios
            .get(this.params.apiUrl + "dict/delivery_options")
            .then((response) => {
              let data = response.data
              this.$store.dispatch("setDeliveryTypes", data)
            })
        }
      }
    },
  },
}
</script>
